var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"install_number_page"},[_c('dec-block-title',[_vm._v("安装数TOP5(台)")]),_c('dv-charts',{attrs:{"option":_vm.option}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }